import Head from 'next/head'
import { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { STUDENT_PANEL_VIEW } from '~/types/student'
import { usePageTitle } from '~/utils/tags'

import PanelWrapper from '~/panels/components/PanelWrapper/PanelWrapper'
import StudentSettings from '~/panels/student/pages/StudentSettings.page'
import { STUDENT_PANEL_TABS } from '~/panels/constants/student-panel'
import AuthGuard from '~/components/AuthGuard'
import { GetProps } from '~/utils/pageWrapper/types'
import { getAllCountries, getRunningQueriesThunk } from '~/redux/apis/countries-api'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

const StudentSettingsPage: NextPage = () => {
  const { t } = useTranslation('studentPanel')
  const title = t('title')
  const pageTitle = usePageTitle(title)

  return (
    <DefaultLayout>
      <Head>
        <title>{pageTitle}</title>
        <meta content="noindex" name="robots" />
      </Head>
      <AuthGuard>
        <PanelWrapper tabs={STUDENT_PANEL_TABS} title={title} view={STUDENT_PANEL_VIEW.SETTINGS}>
          <StudentSettings />
        </PanelWrapper>
      </AuthGuard>
    </DefaultLayout>
  )
}

export const getProps: GetProps = (store) => async () => {
  store.dispatch(getAllCountries.initiate())
  await Promise.all(store.dispatch(getRunningQueriesThunk()))
  return {
    props: {
      namespaces: [
        ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
        'adminPanel',
        'studentPanel',
        'booking',
        'panels',
        'errors',
        'studentInfo',
      ],
    },
  }
}

export const getStaticProps = getStaticPropsWrapper(getProps)

export default StudentSettingsPage
